var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSource({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#58CA6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 32C51 42.4937 42.4937 51 32 51C21.5063 51 13 42.4937 13 32C13 21.5063 21.5063 13 32 13C42.4937 13 51 21.5063 51 32ZM38.65 23.45C39.1539 23.45 39.6372 23.6502 39.9935 24.0065C40.3498 24.3628 40.55 24.8461 40.55 25.35V36.75C40.55 37.2539 40.3498 37.7372 39.9935 38.0935C39.6372 38.4498 39.1539 38.65 38.65 38.65C38.1461 38.65 37.6628 38.4498 37.3065 38.0935C36.9502 37.7372 36.75 37.2539 36.75 36.75V29.9366L26.6933 39.9933C26.3661 40.3204 25.9308 40.517 25.4691 40.546C25.0073 40.575 24.5509 40.4346 24.1853 40.151L24.0067 39.9933C23.6505 39.637 23.4504 39.1538 23.4504 38.65C23.4504 38.1462 23.6505 37.663 24.0067 37.3067L34.0596 27.25H27.25C26.7846 27.2499 26.3355 27.0791 25.9877 26.7698C25.6399 26.4606 25.4177 26.0345 25.3633 25.5723L25.35 25.35C25.35 24.8461 25.5502 24.3628 25.9065 24.0065C26.2628 23.6502 26.7461 23.45 27.25 23.45H38.65Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.46bc0a5a9e2b11eec2d46c99e405253d.svg";
export { ForwardRef as ReactComponent };